var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg00002(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 240",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#999",
    d: "M61.7 26.7c.5 1.6-3 5.2-7.9 4.6-4.9-.6-5.5-9.4 1-10.2 2-.3 6.4 4 6.9 5.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.3 231.5c26.9-13.2 1-17.9-14.1-26.3-20.8-11.6-27.5-15.7-43-6.1-17.1 10.6.2 17.9 16.1 25.3 18 8.4 25 14.9 41 7.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#656565",
    d: "M11.8 210.4c-.3 1.9-.7 3.5 2 4.2 2.6.7 5.4.3 7.9-1.7s3.7-3.1 7.1-4.1 5-4 5-6.5-2.1-4.7-6.5-3.3c-4.5 1.4-6.8 3.3-6.8 3.3l-8.7 8.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.8 202.2c0-.8-.2-1.5-.6-2.2.5 2.2.3 6.4-7.5 8-2.4.5-5.8 3.7-8.3 4.5-1.9.6-4.3 0-5.7-1.1-.2 1.4 0 2.6 2.1 3.2 2.6.7 5.4.3 7.9-1.7s3.7-3.1 7.1-4.1c3.5-1 5-4 5-6.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#656565",
    d: "M51.7 227.3c0 2.6-1.1 5 2.2 5.6 3.3.6 10.3-3.8 13-4.5 2.9-.8 9.9-3.6 9.9-6.1s-2.9-5.2-6.1-5c-3.1.3-9.1.7-9.1.7l-9.9 9.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M76.7 222.3c0-1.4-.9-2.8-2.2-3.8 3.9 4.7-2.5 6.3-6.2 7.3-4.5 1.2-9.5 4.2-12.2 5-1.9.5-3.5-.1-4.6-.7 0 1.4.3 2.5 2.3 2.9 3.3.6 10.3-3.8 13-4.5 2.9-.9 9.9-3.7 9.9-6.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M29.2 98.9c-2.6 4.5-5.2 11.4-6.9 20.4-1.7 9-3.1 28.8-5.8 40.6s-4.6 18.2-6.5 31.2c-1.9 13-2 20.1 1.3 21.6 3.1 1.4 7.9.8 11.1-1.7 4.2-3.2 5.3-7.5 5.3-9.9s2.3-10.3 3.7-16.8 6.5-28.8 9.4-37.6c2.8-8.8 8.5-38.7 8.5-38.7l-20.1-9.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.2 98.9c-2.6 4.5-5.2 11.4-6.9 20.4-1.7 9-3.1 28.8-5.8 40.6s-4.6 18.2-6.5 31.2c-1.9 13-2 20.1 1.3 21.6 3.1 1.4 7.9.8 11.1-1.7 4.2-3.2 5.3-7.5 5.3-9.9s2.3-10.3 3.7-16.8 6.5-28.8 9.4-37.6c2.8-8.8 8.5-38.7 8.5-38.7l-20.1-9.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M36 105.9c-1.7 3.6-2.9 20.2-.9 25.7 2.4 6.4 8.5 32.7 10.1 48.9.5 5.1 2.9 42.2 3 45.8.1 3.5 2.1 4.9 6.4 5.2 4.3.3 13-5.4 13.6-10.3.7-4.9.1-6.3-.1-9s-1.4-17.3-1.6-25.3.5-46.9-1.2-57.8c-1.6-10.9-4.5-21.5-4.5-21.5L36 105.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M65.1 75.2c-2.3-7.7-8.6-13.5-8.6-13.5s.9-5.5-1-6.6-7.8-.6-12.4-2.2c-4.6-1.5-4.2-1.3-4.2-1.3l.5-3s-3.5-1.7-4.8-.5c-1.3 1.2-.8 4.6-.8 4.6s-7.5-1.3-10.2 0c-2.7 1.3-6.2 3.3-8.3 5.6C13.1 61 2.7 72.7 1.5 74.9s-.9 6.6-.3 8.6c1 3.1 6.7 8.9 12.7 11.9 5.8 2.9 8.2 2.3 10.8 4.8-.8 5.4-2.4 9.2-2.2 10.2.3 2.5 4.1 1.9 6.2 3.1 5.9 3.4 21.3 5.3 26.9 5.4 5.6 0 9.4-1.6 9.4-1.6s0-19.6.5-24c.5-3.8 1.9-10.4-.4-18.1zm-46.8 6.4s-.8-1.9.7-2.2 3.7-3.5 3.7-3.5.5 5.7 1.3 11.1c-3-2.5-5.7-5.4-5.7-5.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD7C7",
    d: "M36.7 51.8s2.8-1.4 2.7-5c0-3.6-4.3-11.8 0-18.1s15.7-7.7 20.2.6c4.7 8.6 0 20.2-1.5 21s-3.9.1-4.5.6c-.6.5-.5 2.8-.4 4.3.1 1.6-6.8 2.3-11 1.7-4.1-.4-5.5-5.1-5.5-5.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#825012",
    d: "M39.2 45.3c.4 1.2 2.7 3.3 6.1 3.1s6.9-4.1 7.6-6.3c.7-2.3 1.2-4.1 2.6-3.7s.3 2.4.9 2.4c.7 0 4.8-7.9 4.3-9.8-.3-1.2-1.4-4.6-5.7-7-4.5-2.4-15.1-2.3-17.4 7.4-1.5 6.2 1.6 13.9 1.6 13.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M47.2 213.2l.2 2.5s4 1.6 8.7.9c7.3-1.1 11.9-6.5 11.9-6.5l-.1-2.3s-5 4.8-11.8 6.3c-5.3 1.3-8.9-.9-8.9-.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M46.8 207.6l.2 2.5s4 1.6 8.7.9c7.3-1.1 11.9-6.5 11.9-6.5l-.1-2.3s-5 4.8-11.8 6.3c-5.4 1.3-8.9-.9-8.9-.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#656565",
    d: "M65 107s-.5 5.2-.5 6.1-2.2 3.6-2.2 3.6 0 1.1.3 1.5c.3.3 1 2 1.1 2.4.1.4 4.3-1.4 4.8-3.6s.2-7.7-.9-8.7c-1.2-1.2-2.6-1.3-2.6-1.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M35.6 37.9s-10.3 15.2-.4 16.5c9.9 1.3 22.6-7.6 26.6-14.9 3.2-5.9 4-10.5 1.2-13-2.7-2.4-10.9.7-10.9.7L35.6 37.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M36.9 45c-1.1-.8-5.1-12.9 2.4-20.1s21.5-2.3 22.2 4.7c.7 6.9-15.1 22-24.6 15.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#999",
    d: "M50.7 44.2S62.1 38 62 28.3c0-3.4-4.8-7.2-7.1-7.2 2.5.6 2.7 3.1 2.1 7.8-1.2 8.6-6.3 15.3-6.3 15.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M22.7 75.9l.1-2.5s-2.1-2.6-4.1-5.4-4.1-8.8-4.1-8.8l-2.1 2.4s2.7 6 4.3 8.4c1.6 2.4 5.2 6.8 5.2 6.8l.7-.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M20.6 78.5s-.4.5-1 .8c-.7.3-1.1.4-1.1.4s-3.1-1.8-4.9-4.6c-4-6.1-5-9-5-9l2-2.2s1 3.3 5.3 9.9c1.8 2.9 4.7 4.7 4.7 4.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M22.7 74.9s4 2.9 10.2 5.2c6.2 2.4 16.2 3.9 16.2 3.9l.1 3.3s-7.3-.6-17.3-4.2c-5.9-2.1-9.1-4.3-9.1-4.3l-.1-3.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M23.3 82.9s1.8 2.1 10 5.1c6.3 2.3 16.2 4.3 16.2 4.3l.1 2.9S38.8 93 32.3 90.7c-3.5-1.2-8.4-4.1-8.4-4.1l-.6-3.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M49.4 90.2l.2 3.1s2.8 1.2 7.4 1.7c3.6.4 8.6-.8 8.6-.8l.3-2.8s-3.6 1.5-8.9.9c-5.7-.7-7.6-2.1-7.6-2.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M49.7 96.7l.2 3.1s2.8 1.6 7.4 1.7c3.6.1 8.1-.8 8.1-.8v-2.8s-2.8 1.1-8.1.9c-5.8-.2-7.6-2.1-7.6-2.1z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M9.3 194.9l-.3 2.9s.7 2.7 5.5 3.2c6 .6 14.5-5.5 14.5-5.5l.6-2.8s-9.4 5.7-14.7 5.6c-3.4 0-5.6-3.4-5.6-3.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M10.3 188.7l-.3 2.8s.3 3 5.2 3.5c5.7.6 15.2-5.1 15.2-5.1l.5-2.1s-10.6 5-15.1 4.8c-3.6-.3-5.5-3.9-5.5-3.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg00002);
export default __webpack_public_path__ + "static/media/00002.fa6bd8a2.svg";
export { ForwardRef as ReactComponent };